import { render, staticRenderFns } from "./EquipmentComponent.vue?vue&type=template&id=06707f67"
import script from "./EquipmentComponent.vue?vue&type=script&lang=js"
export * from "./EquipmentComponent.vue?vue&type=script&lang=js"
import style0 from "./EquipmentComponent.vue?vue&type=style&index=0&id=06707f67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports